export default {"src":"/_next/static/media/AAVE.490ea2b3.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};